import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { useAuth } from '../../../contexts/AuthContext';
import maskVehicleNumber from '../../../utils/maskVehicleNumber';

const UNIT_LABELS = ['Kg', 'Quintal', 'Ton'];

const convertRate = (ratePerKg, unit) => {
  if (unit === 'Kg') return { value: ratePerKg?.toFixed(2), label: '/Kg' };
  if (unit === 'Quintal') return { value: (ratePerKg * 100)?.toFixed(0), label: '/Quintal' };
  if (unit === 'Ton') return { value: (ratePerKg * 1000)?.toFixed(0), label: '/Ton' };
  return { value: ratePerKg?.toFixed(2), label: '/Kg' };
};

const TruckCard = ({ truck, onBook }) => {
  const [unit, setUnit] = useState('Kg');
  const { isAuthenticated, user } = useAuth();
  const rate = convertRate(truck?.ratePerKg, unit);
  const isAvailable = truck?.status === 'Available';
  const displayVehicleNumber = maskVehicleNumber(truck?.vehicleNumber, isAuthenticated);

  return (
    <div
      className="rounded-xl border overflow-hidden flex flex-col"
      style={{ backgroundColor: '#ffffff', borderColor: '#e5d9cc' }}
    >
      {/* Card Header */}
      <div className="px-5 pt-5 pb-4 border-b" style={{ borderColor: '#f0e8de' }}>
        <div className="flex items-start justify-between">
          <div>
            <p className="text-xs font-medium mb-1" style={{ color: '#9ca3af' }}>Vehicle Number</p>
            <h3 className="text-lg font-bold tracking-wide" style={{ color: '#1f2937', fontFamily: 'DM Sans, sans-serif' }}>
              {displayVehicleNumber}
            </h3>
          </div>
          <span
            className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold mt-1"
            style={{
              backgroundColor: isAvailable ? '#d1fae5' : '#fef3c7',
              color: isAvailable ? '#065f46' : '#92400e',
            }}
          >
            <span
              className="w-1.5 h-1.5 rounded-full"
              style={{ backgroundColor: isAvailable ? '#10b981' : '#f59e0b' }}
            />
            {truck?.status}
          </span>
        </div>
      </div>
      {/* Card Body */}
      <div className="px-5 py-4 flex-1 space-y-3">
        {/* Capacity */}
        <div className="flex items-center gap-2">
          <Icon name="Package" size={16} color="#d97706" />
          <span className="text-sm" style={{ color: '#6b7280' }}>Capacity</span>
          <span className="ml-auto text-sm font-semibold" style={{ color: '#1f2937' }}>
            {truck?.capacityMT} MT
          </span>
        </div>

        {/* Location */}
        <div className="flex items-center gap-2">
          <Icon name="MapPin" size={16} color="#d97706" />
          <span className="text-sm" style={{ color: '#6b7280' }}>Location</span>
          <span className="ml-auto text-sm font-semibold text-right" style={{ color: '#1f2937', maxWidth: '55%' }}>
            {truck?.currentLocation}
          </span>
        </div>

        {/* Rate with unit toggle */}
        <div className="rounded-lg p-3 mt-1" style={{ backgroundColor: '#fef9f3', border: '1px solid #f0e8de' }}>
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs font-medium" style={{ color: '#9ca3af' }}>Rate</span>
            {/* Unit Toggle */}
            <div className="flex rounded-md overflow-hidden border" style={{ borderColor: '#e5d9cc' }}>
              {UNIT_LABELS?.map((u) => (
                <button
                  key={u}
                  onClick={() => setUnit(u)}
                  className="px-2 py-0.5 text-xs font-medium transition-colors"
                  style={{
                    backgroundColor: unit === u ? '#d97706' : '#ffffff',
                    color: unit === u ? '#ffffff' : '#6b7280',
                  }}
                >
                  {u}
                </button>
              ))}
            </div>
          </div>
          <div className="flex items-baseline gap-1">
            <span className="text-2xl font-bold" style={{ color: '#1f2937' }}>
              ₹{Number(rate?.value)?.toLocaleString('en-IN')}
            </span>
            <span className="text-sm" style={{ color: '#9ca3af' }}>{rate?.label}</span>
          </div>
        </div>
      </div>
      {/* Book Button */}
      <div className="px-5 pb-5">
      </div>
    </div>
  );
};

export default TruckCard;